// extracted by mini-css-extract-plugin
module.exports = {"icons":"styles_icons__1Xx3v"};